module.exports = __webpack_public_path__ + "static/media/IBULHSGFIN_F1.17405eed.txt";